<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title> Add employees </ng-container>
  <ng-container body>
    <p>How would you like to add an employee?</p>

    <button
      id="addNewEmployeeDetails"
      (click)="addNewEmployeeDetails()"
      class="btn-block btn-block__secondary d-block text-body shadow mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <i class="iconoir-user-plus"></i>
        <div class="w-100 text-start">
          <div class="fw-bold">As an individual</div>
          <div class="text-muted">Add a new employee</div>
        </div>
        <i class="iconoir-nav-arrow-right"></i>
      </div>
    </button>

    <button
      id="openBulkUploads"
      (click)="openBulkUploads()"
      class="btn-block btn-block__secondary d-block text-body shadow">
      <div class="d-flex align-items-center justify-content-between">
        <i class="iconoir-upload-square"></i>
        <div class="w-100 text-start">
          <div class="fw-bold">Bulk upload</div>
          <div class="text-muted">Upload a CSV of multiple employees</div>
        </div>
        <i class="iconoir-nav-arrow-right"></i>
      </div>
    </button>
  </ng-container>
</app-offcanvas-base>
